export default {
  NEW_DEVICE_LOG_AVAILABLE: 'new-device-log-available',
  CALA_HEALTH: 'calahealth',
}
